/**
 *
 *
 *
 */
import React from 'react';
import * as Router from 'react-router-dom';
import * as u from '../utils';


/**
 *
 *
 *
 */
export default function Analytics() {

  const location = Router.useLocation();
  React.useEffect(() => { onChange(); }, [location]);
  return null;

  /**
   *
   *
   *
   */
  async function onChange() {
    window.scrollTo(0, 0);
    const url = location.pathname + location.search;
    const screen = window.screen?.width + 'x' + window.screen?.height;
    const items = [{ event_name: 'page_view', data: { url, screen } }];
    const query = 'mutation AnalyticsSubmitEvents($items: JSON!) { analytics_submit_events(items: $items) }';
    await u.fetcher(query, { items });
  }
}
